import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const WIDTH_BY_VARIANT = {
  full: '100%',
  short: '48%',
  medium: '68%'
};

const SkeletonBlock = ({ width, tall }) => (
  <Box
    sx={{
      display: 'block',
      width: WIDTH_BY_VARIANT[width],
      height: tall ? '28px' : '13px',
      borderRadius: '4px',
      background:
        'linear-gradient(90deg, #eef2f6 0%, #f7f9fb 46%, #eef2f6 100%)',
      backgroundSize: '220% 100%',
      animation: 'skeleton-shimmer 1100ms ease-in-out infinite',
      '@keyframes skeleton-shimmer': {
        '0%': { backgroundPosition: '120% 0' },
        '100%': { backgroundPosition: '-120% 0' }
      },
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none'
      }
    }}
  />
);

SkeletonBlock.propTypes = {
  width: PropTypes.oneOf(['full', 'short', 'medium']),
  tall: PropTypes.bool
};

SkeletonBlock.defaultProps = {
  width: 'full',
  tall: false
};

export default SkeletonBlock;
